const $ = jQuery.noConflict()

class HorizontalNav {
    init() {
        this.target = $('.image-accordion__inner, .tablepress-scroll-wrapper .tablepress')

        this.onResize();
        this.target.on('scroll', (e) => this.checkHasScrollMore(e.target) );
    }

    onResize() {
        this.target.each((index, target) => {
            this.toggleShadow(target);
            this.checkHasScrollMore( target )
        });
    }

    toggleShadow( el ) {
        console.log( el.scrollWidth, el.clientWidth );
        if ( el.scrollWidth > el.clientWidth ) {
            el.parentNode.classList.add('has-scroll');
        } else {
            el.parentNode.classList.remove('has-scroll');
        }
    }

    checkHasScrollMore( el ) {
        console.log( el.scrollWidth - el.scrollLeft, el.offsetWidth );

        if ( el.scrollWidth - el.scrollLeft <= el.offsetWidth ) {
            el.parentNode.classList.remove('has-scroll-right');
        } else {
            el.parentNode.classList.add('has-scroll-right');
        }
    }
}

export default new HorizontalNav;